import styled from 'styled-components'

export const SpeciesCriteriaMetContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  width: 100%;
`

export const SpeciesCriteriaMetShell = styled.div`
  width: 100%;
  border: 1px solid rgba(32, 32, 32, 0.1);
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 6px 18px rgba(32, 32, 32, 0.05);
  overflow: visible;
`

export const SpeciesTableToolbarWrapper = styled.div`
  position: sticky;
  top: 0;
  z-index: 5;
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 16px 20px 14px;
  background: linear-gradient(180deg, rgba(248, 249, 250, 1) 0%, rgba(255, 255, 255, 1) 100%);
  border-bottom: 1px solid rgba(32, 32, 32, 0.08);
  border-top-left-radius: 14px;
  border-top-right-radius: 14px;

  @media (max-width: 640px) {
    gap: 12px;
    padding: 14px 14px 12px;
  }
`

export const SpeciesToolbarGrid = styled.div`
  display: grid;
  grid-template-columns: ${(props) => {
    if (props.$filterCount === 2) {
      return 'minmax(260px, 1.15fr) minmax(170px, 1fr) minmax(170px, 1fr)'
    }

    return 'minmax(260px, 1.15fr) repeat(3, minmax(170px, 1fr))'
  }};
  gap: 16px;
  align-items: end;

  @media (max-width: 1100px) {
    grid-template-columns: repeat(2, minmax(200px, 1fr));
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`

export const SpeciesToolbarFilters = styled.div`
  display: contents;
`

export const SpeciesSearchField = styled.div`
  min-width: 0;
`

export const SpeciesFilterField = styled.div`
  min-width: 0;

  label {
    margin-bottom: 6px !important;
    font-size: 13px;
    line-height: 20px;
    font-weight: 600;
    color: rgba(32, 32, 32, 0.82);
  }
`

export const SpeciesFieldLabel = styled.label`
  display: block;
  margin-bottom: 6px;
  font-size: 13px;
  line-height: 20px;
  font-weight: 600;
  color: rgba(32, 32, 32, 0.82);
`

export const SpeciesToolbarMeta = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-top: 2px;

  @media (max-width: 640px) {
    align-items: flex-start;
    flex-direction: column;
  }
`

export const SpeciesResultsSummary = styled.p`
  margin: 0;
  font-size: 13px;
  line-height: 20px;
  color: rgba(32, 32, 32, 0.62);
`

export const SpeciesToolbarClearButton = styled.button`
  border: 1px solid rgba(32, 32, 32, 0.14);
  background: #fff;
  color: #202020;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
  padding: 6px 12px;
  border-radius: 8px;
  transition: background 0.15s ease, border-color 0.15s ease;

  &:hover {
    background: rgba(32, 32, 32, 0.04);
    border-color: rgba(32, 32, 32, 0.22);
  }

  &:focus-visible {
    outline: 2px solid rgba(29, 78, 216, 0.35);
    outline-offset: 2px;
  }
`

export const SpeciesSearchInputContainer = styled.div`
  position: relative;
  width: 100%;
`

export const SpeciesSearchIconWrapper = styled.div`
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  pointer-events: none;
  opacity: 0.55;
`

export const SpeciesSearchClearButton = styled.button`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  background: rgba(32, 32, 32, 0.06);
  border-radius: 999px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;

  &:hover {
    background: rgba(32, 32, 32, 0.12);
  }
`

export const SpeciesSearchInputField = styled.input`
  width: 100%;
  height: 40px;
  padding: 10px 40px 10px 42px;
  border: 1px solid rgba(32, 32, 32, 0.14);
  border-radius: 10px;
  font-size: 14px;
  line-height: 20px;
  background: #fff;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &::placeholder {
    color: rgba(32, 32, 32, 0.45);
  }

  &:hover {
    border-color: rgba(32, 32, 32, 0.22);
  }

  &:focus {
    outline: none;
    border-color: rgba(29, 78, 216, 0.55);
    box-shadow: 0 0 0 3px rgba(29, 78, 216, 0.12);
  }
`

export const SpeciesTableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  overflow-y: visible;
  border: ${(props) => (props.$embedded ? 'none' : '1px solid rgba(32, 32, 32, 0.1)')};
  border-radius: ${(props) => (props.$embedded ? '0' : '8px')};
  -webkit-overflow-scrolling: touch;
  scrollbar-gutter: stable both-edges;

  &::-webkit-scrollbar {
    height: 10px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(32, 32, 32, 0.05);
    border-radius: 999px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(32, 32, 32, 0.22);
    border-radius: 999px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(32, 32, 32, 0.32);
  }
`

export const SpeciesPaginationSummary = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 20px;
  color: rgba(32, 32, 32, 0.72);

  @media (max-width: 640px) {
    font-size: 13px;
    line-height: 18px;
  }
`

export const SpeciesDataTable = styled.table`
  width: max-content;
  min-width: 100%;
  table-layout: auto;
  border-collapse: collapse;

  th,
  td {
    padding: 12px 16px;
    text-align: left;
    border-bottom: 1px solid rgba(32, 32, 32, 0.08);
    font-size: 14px;
    line-height: 20px;
    vertical-align: middle;
    white-space: nowrap;
  }

  th {
    position: sticky;
    top: 0;
    z-index: 1;
    background: linear-gradient(180deg, rgba(248, 249, 250, 1) 0%, rgba(255, 255, 255, 1) 100%);
    font-weight: 600;
    font-size: 13px;
    color: rgba(32, 32, 32, 0.72);
    vertical-align: middle;
  }

  tbody tr:nth-child(even) {
    background: rgba(32, 32, 32, 0.012);
  }

  tbody tr:hover {
    background: rgba(29, 78, 216, 0.035);
  }

  @media (max-width: 900px) {
    th,
    td {
      padding: 10px 12px;
      font-size: 13px;
      line-height: 18px;
    }

    th {
      font-size: 12px;
    }
  }
`

export const SortableHeaderButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0;
  font: inherit;
  color: inherit;
  text-align: inherit;
  white-space: nowrap;

  &:focus-visible {
    outline: 2px solid rgba(29, 78, 216, 0.35);
    outline-offset: 2px;
  }
`

export const SortIndicator = styled.span`
  font-size: 12px;
  color: rgba(32, 32, 32, 0.65);
`

export const NumericCell = styled.div`
  text-align: right;
  white-space: nowrap;
`

export const SpeciesStatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  background: ${(props) => props.$background || 'rgba(32, 32, 32, 0.08)'};
  color: ${(props) => props.$color || '#202020'};
`

export const SpeciesEmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 48px 24px;
  text-align: center;
  color: rgba(32, 32, 32, 0.75);
  border-top: 1px solid rgba(32, 32, 32, 0.06);
`

export const SpeciesClearFiltersButton = styled.button`
  border: none;
  background: transparent;
  color: rgba(29, 78, 216, 1);
  cursor: pointer;
  font-size: 14px;
  text-decoration: underline;

  &:focus-visible {
    outline: 2px solid rgba(29, 78, 216, 0.35);
    outline-offset: 2px;
  }
`

export const SpeciesSkeletonRow = styled.tr`
  td {
    padding: 12px 16px;
  }
`

export const SpeciesSkeletonBlock = styled.div`
  height: 16px;
  border-radius: 4px;
  background: linear-gradient(
    90deg,
    rgba(32, 32, 32, 0.06) 25%,
    rgba(32, 32, 32, 0.12) 50%,
    rgba(32, 32, 32, 0.06) 75%
  );
  background-size: 200% 100%;
  animation: speciesSkeletonPulse 1.2s ease-in-out infinite;

  @keyframes speciesSkeletonPulse {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`
